import React, { useState, useEffect } from "react";
import {
  Stack,
  styled,
  Link,
  Grid,
  Avatar,
  InputAdornment,
  FormControl,
  InputLabel,
  Input,
  Button,
  MenuItem,
  Select,
  Fade,
  Divider,
  FormControlLabel,
  Checkbox,
  Chip,
  FormHelperText, // Add this import
} from "@mui/material";
import {
  TextField,
  Typography,
  makeStyles,
  Container,
  Modal,
  Backdrop,
} from "@material-ui/core";
import { colorTags } from "../../../constants/variants";
import { DropzoneArea } from "material-ui-dropzone";
import { DropzoneAreaBase } from "material-ui-dropzone";

import { useStyles } from "../../../App";
import {
  useGetMembersQuery,
  useGetMemberByIdQuery,
  useCreateMemberRequestMutation,
  useUpdateMemberRequestMutation,
  useDeleteMemberRequestMutation,
  useUploadFileMutation,
  useGetProductsQuery,
  useGetDestinationsQuery,
} from "../../../features/api/apiSlice";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import FacebookIcon from "@mui/icons-material/Facebook";
import LanguageIcon from "@mui/icons-material/Language";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";
import { FILE_DOWNLOAD_URL, FILE_LINK_URL } from "../../../constants/apiTags";
// Add the following import for validation
import { Bars } from "react-loader-spinner";

const useStyless = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    overflow: "auto",
  },
  dropzone: {
    minHeight: "50px !important",
    border: "1px dashed #006738",
    borderRadius: "4px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    padding: theme.spacing(2),
  },
  modalActions: {
    marginTop: theme.spacing(2),
    display: "flex",
    justifyContent: "flex-end",
  },
  modalContent: {
    backgroundColor: "#fff",
    borderRadius: "8px",
    padding: theme.spacing(3),
    boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.2)",
    maxWidth: "70%",
    maxHeight: "90%",
    overflow: "auto",
    outline: "none",
    minWidth: "700px",
  },
  modalTitle: {
    textAlign: "center",
    marginBottom: theme.spacing(2),
  },
  modalBody: {
    marginTop: theme.spacing(2),
  },
  inputField: {
    marginBottom: theme.spacing(2),
  },
  textField: {
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#006738",
      },
      "&:hover fieldset": {
        borderColor: "#006738",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#006738",
      },
    },
    "& .MuiInputLabel-root": {
      color: "#006738",
    },
  },
  // Include other styles...

  // Validation error styles
  validationError: {
    color: "#f44336",
    fontSize: "0.75rem",
    marginTop: "5px",
  },
}));

const EditMember = ({ open, onClose, title, onSave, data }) => {
  const classes = useStyless();
  const classez = useStyles();
  const [companyName, setCompanyName] = useState("");
  const [sector, setSector] = useState("");
  const [subSector, setSubSector] = useState("");
  const [contactPerson, setContactPerson] = useState("");
  const [status, setStatus] = useState("Active");
  const [contactAddress, setContactAddress] = useState("");
  const [contactEmail, setContactEmail] = useState("");
  const [contactPhone, setContactPhone] = useState("");
  const [bio, setBio] = useState("");
  const [coverImage, setCoverImage] = useState([]);
  const [avatar, setAvatar] = useState([]);
  const [coverImageS, setCoverImageS] = useState("");
  const [avatarS, setAvatarS] = useState("");
  const [products, setProducts] = useState([]);
  const [destinations, setDestinations] = useState([]);
  const [socials, setSocials] = useState({
    whatsapp: "",
    linkedIn: "",
    website: "",
  });

  const params = useParams();
  const { data: productsData, isLoading: productsLoading } =
    useGetProductsQuery();
  const { data: destinationsData, isLoading: destinationsLoading } =
    useGetDestinationsQuery();

  const [submitFileUpload] = useUploadFileMutation();
  const [createMemberRequest, { isLoading: createMemberRequestLoading }] =
    useCreateMemberRequestMutation();

  const [showSocialFields, setShowSocialFields] = useState({
    whatsapp: false,
    linkedIn: false,
    website: false,
  });
  // const { data: memberData, isLoading: memberLoading } = useGetMemberByIdQuery({
  //   id: params.id,
  // });
  const [validationErrors, setValidationErrors] = useState({
    companyName: "",
    sector: "",
    subSector: "",
    contactPerson: "",
    status: "",
    contactAddress: "",
    contactEmail: "",
    contactPhone: "",
    bio: "",
  });

  useEffect(() => {
    if (data) {
      setCompanyName(data.companyName);
      setSector(data.sector);
      setSubSector(data.subSector);
      setContactPerson(data.contactPerson);
      setStatus(data.status);
      setContactAddress(data.contactAddress);
      setContactEmail(data.email);
      setContactPhone(data.contactPhone);
      setBio(data.bio);
      setCoverImageS(data.coverImage);
      setAvatarS(data.avatar);
      setProducts(JSON.parse(data?.products));
      setDestinations(JSON.parse(data?.destinations));
      setSocials(JSON.parse(data?.socials));
      // setProducts(data?.products);
      // setDestinations(data?.destinations);
      // setSocials(data?.socials);
      console.log(data);
    }
  }, [data]);

  const [
    updateMemberRequest,
    {
      isLoading: isLoadingUpdateRequest,
      isError: isErrorUpdateRequest,
      error: errorUpdateRequest,
    },
  ] = useUpdateMemberRequestMutation();

  const uploadImage = async (file) => {
    try {
      const formData = new FormData();
      formData.append("file", file);

      const response = await fetch(FILE_LINK_URL, {
        method: "POST",
        body: formData,
      });

      if (response.ok) {
        const data = await response.json();
        // Access the uploaded image data, e.g., data.documentName
        return data;
      } else {
        throw new Error("Image upload failed");
      }
    } catch (error) {
      console.error("Image uploading image:", error);
      throw error;
    }
  };

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const validatePhone = (phone) => {
    const phoneRegex = /^\d{10}$/;
    return phoneRegex.test(phone);
  };

  const validateUrl = (url) => {
    const urlRegex = /^(ftp|http|https):\/\/[^ "]+$/;
    return urlRegex.test(url);
  };
  const storedUser = localStorage.getItem("user");
  const user = storedUser ? JSON.parse(storedUser) : null;

  const handleSave = async (e) => {
    e.preventDefault();

    const updateData = {
      id: data.id,
      companyName,
      sector,
      subSector,
      contactPerson,
      status,
      contactAddress,
      bio,
      email: contactEmail,
      contactPhone,
      products,
      destinations,
      socials,
      userId: user?.user_id,
    };

    if (coverImage.length > 0) {
      try {
        const imageResponse = await uploadImage(coverImage[0]);

        updateData.coverImage =
          imageResponse?.dbPaths[0]?.documentName ?? coverImageS;
      } catch (error) {
        toast.error("Error uploading cover image");
        updateData.coverImage = coverImageS;
        return;
      }
    } else {
      updateData.coverImage = coverImageS;
    }

    if (avatar.length > 0) {
      try {
        const imageResponse = await uploadImage(avatar[0]);

        updateData.avatar = imageResponse?.dbPaths[0]?.documentName ?? avatarS;
      } catch (error) {
        toast.error("Error uploading avatar image");
        updateData.avatar = avatarS;
        return;
      }
    } else {
      updateData.avatar = avatarS;
    }

    await updateMemberRequest(updateData)
      .then((res) => {
        if (res) {
          toast.success("Member created successfully");
        }
      })
      .catch((err) => {
        toast.error("Error creating member");
      });

    onClose();
  };

  const handleCheckboxChange = (field) => {
    setShowSocialFields((prevFields) => ({
      ...prevFields,
      [field]: !prevFields[field],
    }));
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
      className={classes.modal}>
      <Fade in={open}>
        <div className={classes.modalContent}>
          <div className={classes.modalHead}>
            <Typography
              variant="h5"
              className={classes.modalTitle}
              style={{ fontWeight: "medium", color: colorTags.PRIMARY }}>
              {title}
            </Typography>
          </div>
          <Divider style={{ backgroundColor: "#00FF00" }} />
          <div className={classes.modalBody}>
            <Stack direction="row" spacing={2}>
              <TextField
                label="Company Name"
                variant="outlined"
                className={classes.textField}
                required
                fullWidth
                style={{ marginTop: "15px" }}
                value={companyName}
                onChange={(e) => setCompanyName(e.target.value)}
                error={companyName.length > 100}
                helperText={
                  companyName.length > 100 &&
                  "Company name cannot exceed 100 characters"
                }
              />

              <TextField
                label="Contact Person"
                variant="outlined"
                className={classes.textField}
                fullWidth
                style={{ marginTop: "15px" }}
                value={contactPerson}
                onChange={(e) => setContactPerson(e.target.value)}
                error={contactPerson.length > 100}
                helperText={
                  contactPerson.length > 100 &&
                  "Contact person name cannot exceed 100 characters"
                }
              />
            </Stack>
            <Stack direction="row" spacing={2}>
              <TextField
                label="Sector"
                variant="outlined"
                className={classes.textField}
                fullWidth
                style={{ marginTop: "15px" }}
                value={sector}
                onChange={(e) => setSector(e.target.value)}
                error={sector.length > 50}
                helperText={
                  sector.length > 50 &&
                  "Sector name cannot exceed 50 characters"
                }
              />
              <TextField
                label="Sub-Sector"
                variant="outlined"
                className={classes.textField}
                fullWidth
                style={{ marginTop: "15px" }}
                value={subSector}
                onChange={(e) => setSubSector(e.target.value)}
                error={subSector.length > 50}
                helperText={
                  subSector.length > 50 &&
                  "Sub-sector name cannot exceed 50 characters"
                }
              />
            </Stack>
            <Stack direction="row" spacing={2} mt={2}>
              <FormControl
                error={!!validationErrors.status}
                className={classes.formControl}
                style={{ width: "100%" }}>
                <InputLabel>Status</InputLabel>
                <Select
                  color="success"
                  labelId="status"
                  id="status"
                  label="Status"
                  value={status}
                  fullWidth
                  onChange={(e) => setStatus(e.target.value)}>
                  <MenuItem value="Active">Active</MenuItem>
                  <MenuItem value="Inactive">Inactive</MenuItem>
                  <MenuItem value="Banned">Banned</MenuItem>
                </Select>
                <FormHelperText>{validationErrors.status}</FormHelperText>
              </FormControl>

              <TextField
                label="Main Address"
                variant="outlined"
                className={classes.textField}
                fullWidth
                value={contactAddress}
                onChange={(e) => setContactAddress(e.target.value)}
              />
            </Stack>
            <Stack direction="row" spacing={2}>
              <TextField
                label="Contact Email"
                variant="outlined"
                className={classes.textField}
                fullWidth
                type="email"
                required
                style={{ marginTop: "15px" }}
                value={contactEmail}
                onChange={(e) => setContactEmail(e.target.value)}
                error={!validateEmail(contactEmail)}
                helperText={
                  !validateEmail(contactEmail) && "Invalid email format"
                }
              />

              <TextField
                label="Contact Phone"
                variant="outlined"
                className={classes.textField}
                fullWidth
                style={{ marginTop: "15px" }}
                value={contactPhone}
                onChange={(e) => setContactPhone(e.target.value)}
                error={!validatePhone(contactPhone)}
                helperText={
                  !validatePhone(contactPhone) &&
                  "Invalid phone number format. It should be 10 digits"
                }
              />
            </Stack>
            <TextField
              label="Bio"
              variant="outlined"
              className={classes.textField}
              fullWidth
              style={{ marginTop: "15px", marginBottom: "15px" }}
              value={bio}
              onChange={(e) => setBio(e.target.value)}
              error={bio.length > 600}
              helperText={
                bio.length > 600 && "Bio cannot exceed 600 characters"
              }
            />
            {/* ... (other fields) */}
            <Stack direction="row" spacing={2}>
              {/* ... (other fields) */}
            </Stack>
            <FormControl
              error={!!validationErrors.products}
              fullWidth
              style={{ marginTop: "5px" }}>
              <InputLabel>Products</InputLabel>
              <Select
                labelId="products"
                label="Products"
                id="products"
                multiple
                value={products}
                onChange={(e) => setProducts(e.target.value)}
                variant="outlined"
                className={classes.textField}
                fullWidth
                inputProps={{
                  max: 5, // Set the maximum number of selections to 5
                }}>
                {productsData?.map((product) => (
                  <MenuItem key={product?.id} value={product?.productName}>
                    {product?.productName}
                  </MenuItem>
                ))}
              </Select>
              <FormHelperText>{validationErrors.products}</FormHelperText>
            </FormControl>

            <FormControl
              error={!!validationErrors.destinations}
              fullWidth
              style={{ marginTop: "15px" }}>
              <InputLabel>Destinations</InputLabel>
              <Select
                labelId="destinations"
                label="Destinations"
                id="destinations"
                multiple
                value={destinations}
                onChange={(e) => setDestinations(e.target.value)}
                variant="outlined"
                className={classes.textField}
                fullWidth
                inputProps={{
                  max: 5, // Set the maximum number of selections to 5
                }}>
                {destinationsData?.map((destination) => (
                  <MenuItem
                    key={destination?.id}
                    value={destination?.destinationName}>
                    {destination?.destinationName}
                  </MenuItem>
                ))}
              </Select>
              <FormHelperText>{validationErrors.destinations}</FormHelperText>
            </FormControl>

            <FormControlLabel
              control={
                <Checkbox
                  checked={showSocialFields.whatsapp}
                  onChange={() => handleCheckboxChange("whatsapp")}
                />
              }
              label={
                <WhatsAppIcon
                  style={{
                    fontSize: "20px",
                    color: "#25D366",
                  }}
                />
              }
            />
            {showSocialFields.whatsapp && (
              <div>
                <FormControl
                  error={!!validationErrors.whatsapp}
                  fullWidth
                  className={classes.textField}>
                  <InputLabel>WhatsApp</InputLabel>
                  <Input
                    value={socials.whatsapp}
                    placeholder="https://wa.me/923001234567"
                    onChange={(e) =>
                      setSocials((prevSocials) => ({
                        ...prevSocials,
                        whatsapp: e.target.value,
                      }))
                    }
                  />
                  <FormHelperText>{validationErrors.whatsapp}</FormHelperText>
                </FormControl>
              </div>
            )}

            <FormControlLabel
              control={
                <Checkbox
                  checked={showSocialFields.linkedIn}
                  onChange={() => handleCheckboxChange("linkedIn")}
                />
              }
              label={
                <LinkedInIcon
                  style={{
                    fontSize: "20px",
                    color: "#0077B5",
                  }}
                />
              }
            />
            {showSocialFields.linkedIn && (
              <div>
                <FormControl
                  error={!!validationErrors.linkedIn}
                  fullWidth
                  className={classes.textField}>
                  {" "}
                  <InputLabel>LinkedIn</InputLabel>
                  <Input
                    value={socials.linkedIn}
                    placeholder="https://www.linkedin.com/company/aaexport"
                    onChange={(e) =>
                      setSocials((prevSocials) => ({
                        ...prevSocials,
                        linkedIn: e.target.value,
                      }))
                    }
                  />
                  <FormHelperText>{validationErrors.linkedIn}</FormHelperText>
                </FormControl>
              </div>
            )}

            <FormControlLabel
              control={
                <Checkbox
                  checked={showSocialFields.website}
                  onChange={() => handleCheckboxChange("website")}
                />
              }
              label={
                <LanguageIcon
                  style={{
                    fontSize: "20px",
                    color: "blue",
                  }}
                />
              }
            />
            {showSocialFields.website && (
              <div>
                <FormControl
                  error={!!validationErrors.website}
                  fullWidth
                  className={classes.textField}>
                  <InputLabel>Website</InputLabel>
                  <Input
                    value={socials.website}
                    placeholder="https://www.example.com"
                    onChange={(e) =>
                      setSocials((prevSocials) => ({
                        ...prevSocials,
                        website: e.target.value,
                      }))
                    }
                  />
                  <FormHelperText>{validationErrors.website}</FormHelperText>
                </FormControl>
              </div>
            )}
            <div style={{ height: "15px" }}></div>
            <DropzoneArea
              dropzoneClass={classez?.dropZone}
              style={{ height: "200px" }}
              showAlerts={false}
              useChipsForPreview={true}
              filesLimit={1}
              maxFiles={1}
              maxFileSize={5000000}
              acceptedFiles={[
                "image/png",
                "image/jpg",
                "image/jpeg",
                "image/webp",
              ]}
              dropzoneText={
                "Drop or Click to Upload Cover Image (Optional, Max 5MB, JPG, PNG, WEBP, JPEG)"
              }
              onChange={(files) => setCoverImage(files)}
            />
            <div style={{ height: "15px" }}></div>
            <DropzoneArea
              dropzoneClass={classez?.dropZone}
              style={{ height: "200px" }}
              showAlerts={false}
              useChipsForPreview={true}
              filesLimit={1}
              maxFiles={1}
              maxFileSize={5000000}
              acceptedFiles={[
                "image/png",
                "image/jpg",
                "image/jpeg",
                "image/webp",
              ]}
              dropzoneText={
                "Drop or Click to Upload Avatar (Optional, Max 5MB, JPG, PNG, WEBP, JPEG)"
              }
              onChange={(files) => setAvatar(files)}
            />
          </div>
          <div className={classes.modalActions}>
            <Stack spacing={2} direction="row">
              <div className={classes.modalActions} style={{}}>
                <Button
                  variant="contained"
                  color="success"
                  style={{ fontWeight: "bold", color: "#fff" }}
                  onClick={handleSave}>
                  Save
                </Button>

                <Button
                  variant="outlined"
                  style={{ color: "#FF0000", marginLeft: "10px" }}
                  onClick={onClose}>
                  Cancel
                </Button>
              </div>
            </Stack>
          </div>
        </div>
      </Fade>
    </Modal>
  );
};
export default EditMember;
